let previousAlertType;
let activeInfoWindow;

/**
 * display error message per the search query
 *
 * @export
 * @param {string} [message="There was an issue with your request."]
 * @param {string} [type="danger"]
 */
export function showAlert(
    message = "There was an issue with your request.",
    type = "danger"
) {
    $(".alert").removeClass("alert-" + previousAlertType);
    $(".alert").addClass("alert-" + type);
    $(".alert .message").html(message);
    $(".alert").addClass("show");
    $(".alert").show();

    if ($("#search-query").length > 0) {
        if (type === "danger") $("#search-query").trigger("focus");
    }

    // $("html, body").animate({
    //     scrollTop: $(".alert").offset().top - 100,
    // });

    previousAlertType = type;
}

/**
 * handles the opening of a map infowindow
 *
 * @export
 * @param {*} map
 * @param {*} marker
 * @param {*} infoWindow
 * @return {*}
 */
export function openInfoWindow(map, marker, infoWindow) {
    if (activeInfoWindow) {
        activeInfoWindow.close();
    }

    window.dataLayer.push({
        'event': 'studySiteSelect', //fires only on successful study site search
        'formName': 'Study Site Select',   //Pass the form name here  
        'locationName': marker?.title ?? ""   //Pass the selected location Name here
    });

    activeInfoWindow = infoWindow;

    $("html, body").animate(
        {
            scrollTop: $("#map").offset().top,
        },
        function () {
            infoWindow.open({
                anchor: marker,
                map,
                shouldFocus: true,
            });
        }
    );

    return;
}

/**
 * initialize global listeners
 *
 * @export
 */
export function initGlobalListeners() {
    // alerts close
    $(document).on("click", ".alert-close", function () {
        // $(this).parent().hide();
        $(this).parent().removeClass("show");
        $(this).parent().hide();
    });
    // logout action
    $(".admin--logout").on("click", function (e) {
        e.preventDefault();
        document.getElementById("logout-form").submit();
    });
}

export function initQuestions() {
    $("#questionsLocale").on("change", function () {
        $("#questionsLocaleForm").submit();
    });
}
/**
 * initialize jquery-ui sortable lists
 *
 * @export
 */
export function initSortable() {
    // unordered lists with class 'sortable'
    $("#sortableCountries.sortable").each(function (index, item) {
        $(item).sortable({
            stop: function (event, ui) {
                updateCountries();
            },
        });
    });

    // sorted Questions
    $("#sortableQuestions.sortable").each(function (index, item) {
        $(item).sortable({
            stop: function (event, ui) {
                updateQuestions();
            },
        });
    });

    /**
     * update list of active countries
     *
     */
    function updateCountries() {
        const list = $("#sortableCountries li");

        let payload = [];

        $(list).each(function (idx, el) {
            const newObject = {
                code: $(el).data("country"),
                sort_order: $(el).data("order"),
            };
            payload.push(newObject);
        });

        console.log(payload);

        $.ajax({
            type: "POST",
            url: "/api/countries/update",
            data: JSON.stringify(payload),
            contentType: "application/json",
            success(res) {
                console.log("api:");
                console.log(res);
            },
            error(xhr, status, err) {
                console.error(err);
            },
        });
    }

    /**
     * update questions and sort order
     *
     */
    function updateQuestions() {
        const list = $("#sortableQuestions li");

        let payload = [];

        $(list).each(function (idx, el) {
            const newObject = {
                question_id: $(el).data("id"),
                sort_order: $(el).data("order"),
            };
            payload.push(newObject);
        });

        console.log(payload);

        $.ajax({
            type: "POST",
            url: "/api/questions/update",
            data: JSON.stringify(payload),
            contentType: "application/json",
            success(res) {
                console.log("api:");
                console.log(res);
            },
            error(xhr, status, err) {
                console.error(err);
            },
        });
    }
}

// export function showSingleSite(site) {
//     // populate card info...
//     let card = $("#result-card-template").clone().removeClass("template");

//     // card.attr("id", "sitecard-" + key);
//     card.find(".card-subtitle").html(
//         "Site ID: " +
//             site.identifier.toUpperCase() +
//             "<br>Distance: " +
//             Number.parseFloat(site.distance).toFixed(2) +
//             "mi."
//     );
//     card.find(".card-title").html(site.name);
//     card.find(".card-text").html();
//     card.find(".card-title").on("click", function (e) {
//         e.preventDefault();
//         openInfoWindow(map, marker, infoWindow);
//     });

//     if (site.active == false) {
//         card.find(".recruitment").html(recruitmentMessage);
//     }

//     let investigators = JSONParser.parse(site.investigators);

//     $.each(investigators, function (key3, investigator) {
//         // console.log(investigator);
//         let investEl = $("#result-investigator-template")
//             .clone()
//             .removeClass("template");
//         investEl.attr("id", "siteinvestigator-" + key3);
//         investEl.find(".name").html("Investigator: " + investigator.name);

//         investEl.appendTo(card.find(".card-investigators"));
//     });

//     // populate contacts
//     let contacts = JSONParser.parse(site.contacts);
//     $.each(contacts, function (key, contact) {
//         let contactEl = $("#result-contact-template")
//             .clone()
//             .removeClass("template");
//         contactEl.attr("id", "sitecontact-" + key);
//         contactEl.find(".name").html(contact.name);
//         contactEl.find(".phone").html(contact.phone);
//         contactEl.find(".email_text").html(contact.email);
//         contactEl
//             .find(".email a")
//             .attr(
//                 "href",
//                 "mailto:" +
//                     contact.email +
//                     "?subject=" + encodeURIComponent(window.siteConfig.studyContactEmailSubject)
//             );
//         contactEl.appendTo(card.find(".card-contacts"));
//     });
//     // card.appendTo(wrapper);
//     $(groupEl).prependTo(card);

//     $(card).appendTo(newSlide);
// }
